import { administrationRequests } from "api/administrationApi";
import { SPECIFIC_REQUIREMENTS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const SpecificRequirementsExporter = createExporter(
  `${SPECIFIC_REQUIREMENTS}.xlsx`,
  [
    { key: "nameBg", label: "име на български" },
    { key: "nameEn", label: "име на английски" },
    { key: "documentTypes", label: "документи" },
  ],
  record => ({
    ...record,
    documentTypes: Array.isArray(record.documentTypes) ? record.documentTypes.map(d => d?.name).join(", ") : "",
  }),
  [
    {
      source: "documentTypeIds",
      target: administrationRequests.getPreferenceDocumentTypesSelect(),
      name: "documentTypes",
    },
  ],
);
